"use client"

import { useState, useEffect } from "react"
import { Loader2, LayoutGrid } from "lucide-react"
import PostCard from "@/components/PostCard"
import JobCard from "@/components/JobCard"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ActivityItem = any

interface ProfileActivityProps {
  userId: string
  currentUserId?: string
}

export default function ProfileActivity({ userId, currentUserId }: ProfileActivityProps) {
  const [items, setItems] = useState<ActivityItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    const fetchActivity = async () => {
      try {
        const res = await fetch(`/api/profile/${userId}/activity`)
        if (!res.ok) throw new Error("Failed to load")
        const data = await res.json()
        setItems(data.activity || [])
      } catch {
        setError("Could not load activity.")
      } finally {
        setLoading(false)
      }
    }
    fetchActivity()
  }, [userId])

  const handlePostDeleted = (postId: string) => {
    setItems((prev: ActivityItem[]) => prev.filter((item: ActivityItem) => item.id !== postId))
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
      </div>
    )
  }

  if (error) {
    return <p className="text-center text-sm text-gray-400 py-8">{error}</p>
  }

  if (items.length === 0) {
    return (
      <div className="text-center py-12">
        <LayoutGrid className="mx-auto h-10 w-10 text-gray-300 mb-3" />
        <p className="text-sm text-gray-500">No posts or jobs yet.</p>
      </div>
    )
  }

  return (
    <div>
      {items.map((item: ActivityItem) =>
        item.itemType === "post" ? (
          <PostCard
            key={item.id}
            post={item}
            currentUserId={currentUserId}
            onDelete={handlePostDeleted}
          />
        ) : (
          <JobCard key={item.id} job={item} />
        )
      )}
    </div>
  )
}
